import Canvas from 'components/Canvas/Canvas';
import LeftPanel from 'components/Panel/LeftPanel';
import UI from 'components/UI';
import { shallowEqual, useSelector } from 'react-redux';
import { RootReducer } from 'redux/reducers';
import Island from 'components/Island';
import * as S from './styles';

const Workspace = () => {
	const { panelsVisible } = useSelector((r: RootReducer) => {
		return {
			panelsVisible: r.mode.panelsVisible,
		};
	}, shallowEqual);

	return (
		<>
			<S.Workspace>
				<Canvas />
				<UI />
			</S.Workspace>
			{panelsVisible && (
				<S.Panels>
					<S.LeftPanels>
						<LeftPanel />
					</S.LeftPanels>
				</S.Panels>
			)}
			<Island />
		</>
	);
};

export default Workspace;
